import configData from "../config/config.json";

export const getEntities = async(authHeaderValue, enabled = 'Y') => {
    try{
        const url = configData.CCBHTableauAPIServer + "/entities";

        const response = await fetch(url, { 
            method:"POST", 
            headers: {'Authorization':authHeaderValue,
                      'Content-Type': 'application/json',
                      'Access-Control-Allow-Origin':'*'},
            body: JSON.stringify({
                "enabled": enabled
            }),
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }        

};

export const getEntityTypes = async(authHeaderValue) =>{
    try{
        const url = configData.CCBHTableauAPIServer + "/entityTypes";

        const response = await fetch(url, { 
            method:"GET", 
            headers: {'Authorization':authHeaderValue,
                      'Content-Type': 'application/json',
                      'Access-Control-Allow-Origin':'*'
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
};


export const addEntity = async(authHeaderValue, entity_id, entity_type_id, entity_name) =>{
    const url = configData.CCBHTableauAPIServer + "/entity/add";

    const response = await fetch(url, {
        method: "POST",
        headers:{'Authorization':authHeaderValue,
                 'Content-Type': 'application/json',
                 'Access-Control-Allow-Origin':'*',
                 'Content-Type': 'application/json'},
        body: JSON.stringify({
            "name": entity_name,
            "id": entity_id,
            "type": parseInt(entity_type_id),
            "typeDescription": "new",
            "role": "new",
            "enabled": true
        }),
    });
    const responseJson = await response.json();
    console.log('Add Entity response:', responseJson);
    
    return responseJson;
};

export const delDisableEntity = async(authHeaderValue, entityId, disable) => {
    const url = configData.CCBHTableauAPIServer + "/entity/delDisable";

    const response = await fetch(url, {
        method: "POST",
        headers:{'Authorization':authHeaderValue,
                 'Content-Type': 'application/json',
                 'Access-Control-Allow-Origin':'*',
                 'Content-Type': 'application/json'},
        body: JSON.stringify({
            "id": entityId,
            "disable_YN": disable
        }),
    });
    const responseJson = await response.json();
    console.log('Del/Disable Entity response:', responseJson);
    
    return responseJson;
};

export const setEnableEntity = async(authHeaderValue, entityId) => {
    const url = configData.CCBHTableauAPIServer + "/entity/enable";

    const response = await fetch(url, {
        method: "POST",
        headers:{'Authorization':authHeaderValue,
                 'Content-Type': 'application/json',
                 'Access-Control-Allow-Origin':'*',
                 'Content-Type': 'application/json'},
        body: JSON.stringify({
            "id": entityId,
            "disable_YN": 'Y'
        }),
    });
    const responseJson = await response.json();
    console.log('Del/Disable Entity response:', responseJson);
    
    return responseJson;

};

export const getUserRoleTypes = async(authHeaderValue) => {
    try{
        const url = configData.CCBHTableauAPIServer + "/userrolestypes";

        const response = await fetch(url, { 
            method:"GET", 
            headers: {'Authorization':authHeaderValue,
                      'Content-Type': 'application/json',
                      'Access-Control-Allow-Origin':'*'
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }

};

export const refreshDirectReports = async(authHeaderValue, managerId) => {
    const url = configData.CCBHTableauAPIServer + "/RefreshDirectReports?webuserID=" + managerId ;
    try{
        const response = await fetch(url, {
            method:"GET",
            headers: {'Authorization':authHeaderValue,
                      'Content-Type': 'application/json',
                      'Access-Control-Allow-Origin':'*',
                      'webuserID': managerId
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
}

export const deleteWebuserId = async(authHeaderValue, webuserID) => {
    const url = configData.CCBHTableauAPIServer + "/deleteuser?webuserID=" + webuserID;
    try{
        const response = await fetch(url, {
            method:"POST",
            headers:{'Authorization':authHeaderValue,
                     'Content-Type': 'application/json',
                     'Access-Control-Allow-Origin':'*',
                     "webuserID": webuserID
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
}

// Allow Anonymous Access because sends a password link to users registered email address
export const validUser = async(webuserID) => {
    const url = configData.CCBHTableauAPIServer + "/validuser?webuserID=" + webuserID;
    try{
        const response = await fetch(url, { 
            method:"GET", 
            headers: {'Content-Type': 'application/json',
                     'Access-Control-Allow-Origin':'*',
                     'webuserID': webuserID,
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }    
}

// Allow Anonymous Access because sends a password link to users registered email address
export const validTimeStamp = async(webuserID) => {
    const url = configData.CCBHTableauAPIServer + "/password/validatetimestamp?username=" + webuserID;
    try{
        const response = await fetch(url, { 
            method:"GET", 
            headers: {'Content-Type': 'application/json',
                     'Access-Control-Allow-Origin':'*',
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }    
}

// Allow Anonymous Access because sends a password link to users registered email address
export const changePassword = async(username, password) => {
    const url = configData.CCBHTableauAPIServer + "/password/changepassword"; //?webuserID=" + username + "&password=" + password;
    const response = await fetch(url,{
        method: "POST",
        headers: {'Access-Control-Allow-Origin':'*',
                  'Content-Type': 'application/json'},
        body: JSON.stringify({
            'webuserid': username,
            "password": password,
            "managerId":'manager',
            "roles": []
        }),
    });
    const responseJson = await response.json();
    console.log('Password changed', responseJson);
    
    return responseJson;
}

export const getUser = async(authHeaderValue, username) => {
    try{
        const url = configData.CCBHTableauAPIServer + "/user?username=" + username;

        const response = await fetch(url, { 
            method:"GET", 
            headers: {'Authorization':authHeaderValue,
                      'Content-Type': 'application/json',
                      'Access-Control-Allow-Origin':'*'
            },
        });
        console.log(response);
        const responseJson = await response.json();

        return responseJson;
    }catch(err){
        console.log(err.message);
    }        
}

